import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@app/services/auth.service';

@Component({
    selector: 'nav-profile',
    templateUrl: './nav-profile.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.header-nav-item]': 'true'
    }
})
export class NavProfileComponent implements OnInit {
    currentUser = this.auth.currentUserValue;
    username:any=(this.currentUser.username)? this.currentUser.username.slice(0, 1).toUpperCase() : 'IN';
    constructor(private auth: AuthService) { }

    profileMenuList = [
        {
            path: '',
            icon: 'feather icon-user',
            item: 'Profile'
        },
        {
            path: '',
            icon: 'feather icon-settings',
            item: 'Settings'
        },
        {
            path: '',
            icon: 'feather icon-life-buoy',
            item: 'Support'
        },
        {
            path: '',
            icon: 'feather icon-power',
            item: 'Sign Out'
        }
    ]

    ngOnInit(): void {
        // console.log(this.currentUser)
    }
    logoutUser(){
        this.auth.logoutUserData();
    }
}
